import { useSEO } from '@/hooks/useSEO';
import PageNavbar from "@/components/feature/PageNavbar";
import Footer from "@/pages/home/components/Footer";
import HospitalHero from "./components/HospitalHero";
import HospitalOverview from "./components/HospitalOverview";
import HospitalProducts from "./components/HospitalProducts";
import HospitalProcess from "./components/HospitalProcess";
import HospitalGallery from "./components/HospitalGallery";
import HospitalInquiry from "./components/HospitalInquiry";

const SITE_URL = (import.meta.env.VITE_SITE_URL as string) || 'https://isman.co.ke';

const HOSPITAL_SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Hospital & Pharmacy Equipment Installation Kenya",
    "url": SITE_URL + "/hospital-pharmacy",
    "description": "Specialist hospital and pharmacy equipment supply, installation and maintenance in Kenya. Stainless steel counters, medical gas systems, autoclave and laboratory equipment by ISMAN Engineering.",
    "provider": {
      "@type": "LocalBusiness",
      "name": "ISMAN Engineering Company",
      "url": SITE_URL,
      "telephone": "+254724114555"
    },
    "areaServed": { "@type": "Country", "name": "Kenya" },
    "serviceType": "Hospital & Pharmacy Equipment"
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": SITE_URL },
      { "@type": "ListItem", "position": 2, "name": "Hospital & Pharmacy", "item": SITE_URL + "/hospital-pharmacy" }
    ]
  }
];

export default function HospitalPharmacyPage() {
  useSEO({
    title: 'Hospital & Pharmacy Equipment Kenya | ISMAN Engineering Nairobi',
    description: 'Specialist hospital and pharmacy equipment installation in Kenya — stainless steel counters, medical gas systems, autoclave and lab equipment. Trusted by healthcare facilities across Kenya.',
    keywords: 'hospital equipment Kenya, pharmacy equipment Nairobi, medical gas systems Kenya, hospital stainless steel Kenya, laboratory equipment Kenya',
    canonical: SITE_URL + '/hospital-pharmacy',
    schema: HOSPITAL_SCHEMA,
  });

  return (
    <div className="min-h-screen">
      <PageNavbar />
      <HospitalHero />
      <HospitalOverview />
      <HospitalProducts />
      <HospitalProcess />
      <HospitalGallery />
      <HospitalInquiry />
      <Footer />
    </div>
  );
}
